import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function table(theme: Theme): ComponentStyle {
  return {
    componentName: 'table',
    baseStyle: {
      background: theme.colors.hype.background60,
      borderRadius: theme.sizes['0']
    },
    variants: {
      insideCard: {
        padding: 0,
        border: 'none',
        borderRadius: 0
      }
    }
  };
}
